import React from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import { FormLabel, FormControlLabel } from '@material-ui/core';
import { ModalOKCancel } from '../../modals';
import api from '../../ApiService';
import { toast } from 'react-toastify';
import { EditorHeader } from '../EditorHeader';
import { UserRoles } from '../../helper';
import TypeAheadSelect from '../TypeAheadSelect';

export default class Details extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showReloadGoogleAnalyticsModal: false,
            showReloadDataModal: false
        };
    }

    onClickReloadAnalytics = async (e) => {
        this.setState({ showReloadGoogleAnalyticsModal: true });
    }

    onReloadGoogleAnalyticsOK = async (e) => {
        this.setState({ showReloadGoogleAnalyticsModal: false });
        toast.warn('Requesting reload...', { autoClose: false, position: 'bottom-right' });
        var err = await api.reloadGoogleAnalytics(this.props.selectedHospital.nameHash);
        toast.dismiss();
        if (!err) {
            toast.success('Google Analytics reload has been triggered.');
        }
        else {
            toast.error(err, { autoClose: 7000 });
        }
    }

    onReloadGoogleAnalyticsCancel = async (e) => {
        this.setState({ showReloadGoogleAnalyticsModal: false });
    }

    onClickReloadData = async (e) => {
        this.setState({ showReloadDataModal: true });
    }

    onReloadDataOK = async (e) => {
        this.setState({ showReloadDataModal: false });
        toast.warn('Requesting reload...', { autoClose: false, position: 'bottom-right' });
        var err = await api.reloadData(this.props.selectedHospital.nameHash);
        toast.dismiss();
        if (!err) {
            toast.success('Data reload has been triggered.');
        }
        else {
            toast.error(err, { autoClose: 7000 });
        }
    }

    onReloadDataCancel = async (e) => {
        this.setState({ showReloadDataModal: false });
    }

    renderSaveCancel = (columnSpread) => {
        return (
            <Grid item xs={columnSpread} style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }} >
                <Button variant='contained' color='default' style={{ marginRight: '15px', width: '80px' }} onClick={this.props.onClickCancel} disabled={!this.props.isDirty}>Cancel</Button>
                <Button variant='contained' color='primary' style={{ width: '80px' }} onClick={this.props.onClickSave} disabled={!this.props.isDirty}>Save</Button>
            </Grid>
        );
    }

    render() {
        // Override most 'shrink' label attributes when read-only.  If not read-only, use
        // 'undefined' to ensure default behavior. Note: 'null' is treated as 'false', which is
        // not the same as default behavior.
        let isReadOnly = this.props.userRole !== UserRoles.Administrator
            && this.props.userRole !== UserRoles.SuperUser
            && this.props.userRole !== UserRoles.StaffManagement;
        let isDisabledForStaffManagement = this.props.userRole === UserRoles.StaffManagement;
        let shrinkOverride = isReadOnly ? true : undefined;

        let header;
        if (isReadOnly) {
            header = '';
        }
        else if (this.props.selectedHospital.idiVetUser === 0) {
            header = 'Add Hospital';
        }
        else {
            header = 'Edit Hospital';
        }

        // Affiliate dropdown.
        let selectedAffiliateDropdown = null;
        let affiliateId = this.props.selectedHospital.affiliateId;
        let affiliate = this.props.affiliates.find(function (a) {
            return a.id === affiliateId;
        });

        if (affiliate) {
            selectedAffiliateDropdown = {
                value: affiliate.id,
                label: affiliate.name,
                id: affiliate.id
            };
        }

        // Creating a string of users given additional access
        let additionalAccessUserNames = this.props.staffUsers.filter(user => this.props.selectedHospital.iVetUserAppUserAccessUserIds.find(id => id === user.id)).map(user => user.name).join(', ');

        let physicalLocations = this.props.selectedHospital.physicalLocations === 0 || this.props.selectedHospital.physicalLocations
            ? this.props.selectedHospital.physicalLocations : '';

        let examRooms = this.props.selectedHospital.examRooms === 0 || this.props.selectedHospital.examRooms
            ? this.props.selectedHospital.examRooms : '';

        // Note: By adding the defaultValue as a key, we can ensure that the component is recreated and thus will be able to update
        // the defaultValue, thus giving us the ability to use onBlur rather than onChange to update state and speed up the form
        // Doing this on TextFields but not other fields since they are already fast enough

        // ?? What if I split every field out of the object. pretty cumbersome.
        return (
            <div>
                <Grid container spacing={24}>
                    <Grid item xs={6}>
                        <EditorHeader text={header} isNew={this.props.selectedHospital.idiVetUser === 0} />
                    </Grid>
                    {!isReadOnly && this.renderSaveCancel(6)}
                    {isReadOnly && <Grid item xs={6} />}
                    <Grid item xs={3}>
                        <TextField id='name' label='Vet ID *'
                            defaultValue={this.props.selectedHospital.name} key={this.props.selectedHospital.name}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement}
                            fullWidth inputProps={{ maxLength: "64" }} InputLabelProps={{ shrink: shrinkOverride }}
                        />
                    </Grid>

                    <Grid item xs={5}>
                        {!isReadOnly &&
                            <FormControl component="fieldset" style={{ paddingLeft: '30px', display: 'flex' }} disabled={isReadOnly || isDisabledForStaffManagement} >
                                <FormLabel>Status</FormLabel>
                                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                                <FormControlLabel disabled={isReadOnly || isDisabledForStaffManagement}
                                    label='Active'
                                    labelPlacement='end'
                                    control={
                                        <Checkbox
                                            checked={this.props.selectedHospital.isActive === true}
                                            onChange={(e) => this.props.handleCheckboxChange(e, 'isActive')}
                                            value={'isActive'}
                                            color='primary'
                                        />
                                    }
                                />
                                <FormControlLabel disabled={isReadOnly || isDisabledForStaffManagement}
                                    label='Send Email'
                                    labelPlacement='end'
                                    control={
                                        <Checkbox
                                            checked={this.props.selectedHospital.sendClientListEmail === true}
                                            onChange={(e) => this.props.handleCheckboxChange(e, 'sendClientListEmail')}
                                            value={'sendClientListEmail'}
                                            color='primary'
                                        />
                                    }
                                />
                                <FormControlLabel disabled={isReadOnly || isDisabledForStaffManagement}
                                    label='Show Analyst'
                                    labelPlacement='end'
                                    control={
                                        <Checkbox
                                            checked={this.props.selectedHospital.showAnalystUi === true}
                                            onChange={(e) => this.props.handleCheckboxChange(e, 'showAnalystUi')}
                                            value={'showAnalystUi'}
                                            color='primary'
                                        />
                                    }
                                />
                                <FormControlLabel disabled={isReadOnly || isDisabledForStaffManagement}
                                    label='Corporate'
                                    labelPlacement='end'
                                    control={
                                        <Checkbox
                                            checked={this.props.selectedHospital.isCorporate === true}
                                            onChange={(e) => this.props.handleCheckboxChange(e, 'isCorporate')}
                                            value={'isCorporate'}
                                            color='primary'
                                        />
                                    }
                                />
                                </div>
                            </FormControl>
                        }
                    </Grid>

                    <Grid item xs={4}>
                        {!isReadOnly &&
                            <FormControl component="fieldset" style={{ paddingLeft: '30px' }} disabled={isReadOnly || isDisabledForStaffManagement}>
                                <FormLabel>Report Status</FormLabel>
                                <RadioGroup row name="status" value={this.props.selectedHospital.status} onChange={this.props.handleRadioChange}>
                                    <FormControlLabel value='1' control={<Radio checked={this.props.selectedHospital.status === 1} />} label="On" />
                                    <FormControlLabel value='0' control={<Radio checked={this.props.selectedHospital.status === 0} />} label="Off" />
                                </RadioGroup>
                            </FormControl>
						}
                    </Grid>

                    <Grid item xs={8}>
                        <TextField id='description' label='Hospital Name *' defaultValue={this.props.selectedHospital.description} key={this.props.selectedHospital.description}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement}
                            fullWidth inputProps={{ maxLength: "128" }} InputLabelProps={{ shrink: shrinkOverride }}
                        />
                    </Grid>

                    <Grid item xs={4}>
                        {!isReadOnly &&
                            <FormControl component="fieldset" style={{ paddingLeft: '30px' }} disabled={isReadOnly || isDisabledForStaffManagement}>
                                <FormLabel>API Sync Status</FormLabel>
                                <RadioGroup row name="sync" value={this.props.selectedHospital.sync} onChange={this.props.handleRadioChange}>
                                    <FormControlLabel value='1' control={<Radio checked={this.props.selectedHospital.sync === 1} />} label="On" />
                                    <FormControlLabel value='0' control={<Radio checked={this.props.selectedHospital.sync === 0} />} label="Off" />
                                </RadioGroup>
                            </FormControl>
                        }
                    </Grid>

                    <Grid item xs={3}>
                        {/* Still need to rename firstBillDate to serviceStartDate on backend */}
                        <TextField id='firstBillDate' type='date' InputLabelProps={{ shrink: true }} label='Service Start Date'
                            defaultValue={this.props.selectedHospital.firstBillDate || ''} key={this.props.selectedHospital.firstBillDate || ''}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement} fullWidth
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField id='terminationDate' type='date' InputLabelProps={{ shrink: true }} label='Termination Date'
                            defaultValue={this.props.selectedHospital.terminationDate || ''} key={this.props.selectedHospital.terminationDate || ''}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement} fullWidth
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField id='acquisitionDate' type='date' InputLabelProps={{ shrink: true }} label='Acquisition Date'
                            defaultValue={this.props.selectedHospital.acquisitionDate || ''} key={this.props.selectedHospital.acquisitionDate || ''}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement} fullWidth
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField id='webLaunchDate' type='date' InputLabelProps={{ shrink: true }} label='Web Launch Date'
                            defaultValue={this.props.selectedHospital.webLaunchDate || ''} key={this.props.selectedHospital.webLaunchDate || ''}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement} fullWidth
                        />
                    </Grid>

                    <Grid item xs={3}>
                        <FormControlLabel disabled={isReadOnly || isDisabledForStaffManagement}
                            label='Learning Vet Client'
                            labelPlacement='end'
                            control={
                                <Checkbox
                                    checked={this.props.selectedHospital.isLearningVetClient === true}
                                    onChange={(e) => this.props.handleCheckboxChange(e, 'isLearningVetClient')}
                                    value={'isLearningVetClient'}
                                    color='primary'
                                />
                            }
                        />
                    </Grid>

                    <Grid item xs={3}>
                        <TextField id='learningVetStartDate' type='date' InputLabelProps={{ shrink: true }} label='Learning Vet Start Date'
                            defaultValue={this.props.selectedHospital.learningVetStartDate || ''} key={this.props.selectedHospital.learningVetStartDate || ''}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement} fullWidth
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField id='learningVetTerminationDate' type='date' InputLabelProps={{ shrink: true }} label='Learning Vet Termination Date'
                            defaultValue={this.props.selectedHospital.learningVetTerminationDate || ''} key={this.props.selectedHospital.learningVetTerminationDate || ''}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement} fullWidth
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField id='learningVetRate' type='number' InputLabelProps={{ shrink: shrinkOverride }} label='Learning Vet Rate'
                            defaultValue={this.props.selectedHospital.learningVetRate || ''} key={this.props.selectedHospital.learningVetRate || ''}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement} fullWidth
                        />
                    </Grid>

                    <Grid item xs={3}>
                        <TextField id='address' label='Address *' defaultValue={this.props.selectedHospital.address} key={this.props.selectedHospital.address}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement}
                            fullWidth inputProps={{ maxLength: "64" }} InputLabelProps={{ shrink: shrinkOverride }}
                        />
                    </Grid>

                    <Grid item xs={3}>
                        <TextField id='city' label='City *' defaultValue={this.props.selectedHospital.city} key={this.props.selectedHospital.city}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement}
                            fullWidth inputProps={{ maxLength: "50" }} InputLabelProps={{ shrink: shrinkOverride }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField id='state' label='State *' defaultValue={this.props.selectedHospital.state} key={this.props.selectedHospital.state}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement}
                            fullWidth inputProps={{ maxLength: "50" }} InputLabelProps={{ shrink: shrinkOverride }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField id='zip' label='Postal Code *' defaultValue={this.props.selectedHospital.zip} key={this.props.selectedHospital.zip}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement}
                            fullWidth inputProps={{ maxLength: "50" }} InputLabelProps={{ shrink: shrinkOverride }}
                        />
                    </Grid>

                    <Grid item xs={3}>
                        <TextField id='region' label='Region *' defaultValue={this.props.selectedHospital.region} key={this.props.selectedHospital.region}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement}
                            fullWidth inputProps={{ maxLength: "50" }} InputLabelProps={{ shrink: shrinkOverride }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField id='country' label='Country' defaultValue={this.props.selectedHospital.country} key={this.props.selectedHospital.country}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement}
                            fullWidth inputProps={{ maxLength: "50" }} InputLabelProps={{ shrink: shrinkOverride }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField id='deliveryTeam' label='Delivery Team' defaultValue={this.props.selectedHospital.deliveryTeam} key={this.props.selectedHospital.deliveryTeam}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement}
                            fullWidth inputProps={{ maxLength: "50" }} InputLabelProps={{ shrink: shrinkOverride }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <FormControl fullWidth disabled={isReadOnly || isDisabledForStaffManagement}>
                            {this.props.selectedHospital.pms &&
                                <InputLabel htmlFor='pms' shrink>PMS *</InputLabel>
                            }
                            <div className='align-bottom' style={{ paddingTop: '10px' }}>
                                <TypeAheadSelect
                                    value={
                                        this.props.selectedHospital.pms
                                            ? { value: this.props.selectedHospital.pms, label: this.props.selectedHospital.pms }
                                            : null
                                    }
                                    onChange={option => {
                                        const event = {
                                            target: {
                                                name: 'pms',
                                                value: option ? option.value : ''
                                            }
                                        };
                                        this.props.handleBlur(event);
                                    }}
                                    placeholder="PMS *"
                                    disabled={isReadOnly || isDisabledForStaffManagement}
                                    options={this.props.iVetPMS.map(x => ({
                                        value: x.name,
                                        label: x.name,
                                        id: x.id
                                    }))}
                                    inputId="pms"
                                />
                            </div>
                        </FormControl>

                    </Grid>

                    <Grid item xs={3}>
                        <FormControl fullWidth disabled={isReadOnly || isDisabledForStaffManagement}>
                            {this.props.selectedHospital.affiliateId !== 0 &&
                                <InputLabel htmlFor='affiliateId' shrink>Affiliation *</InputLabel>
                            }
                            <div className='align-bottom' style={{ paddingTop: '10px' }} >
                                <TypeAheadSelect
                                    value={selectedAffiliateDropdown}
                                    onChange={this.props.handleAffiliateChange}
                                    placeholder='Affiliation *'
                                    disabled={isReadOnly || isDisabledForStaffManagement}
                                    options={this.props.affiliates.map(affiliate => ({ value: affiliate.id, label: affiliate.name, id: affiliate.id }))}
                                />
                            </div>
                        </FormControl>
                    </Grid>

                    <Grid item xs={3}>
                        <FormControl fullWidth disabled={isReadOnly || isDisabledForStaffManagement}>
                            {this.props.selectedHospital.gpoOptionId &&
                                <InputLabel htmlFor='gpoOptionId' shrink>GPO</InputLabel>
                            }
                            <div className='align-bottom' style={{ paddingTop: '10px' }}>
                                <TypeAheadSelect
                                    value={
                                        this.props.selectedHospital.gpoOptionId
                                            ? (() => {
                                                const selected = this.props.gpoOptions.find(x => x.id === this.props.selectedHospital.gpoOptionId);
                                                return selected ? { value: selected.id, label: selected.name, id: selected.id } : null;
                                            })()
                                            : null
                                    }
                                    onChange={option => {
                                        const event = {
                                            target: {
                                                name: 'gpoOptionId',
                                                value: option ? option.value : ''
                                            }
                                        };
                                        this.props.handleBlur(event);
                                    }}
                                    placeholder="GPO"
                                    disabled={isReadOnly || isDisabledForStaffManagement}
                                    options={this.props.gpoOptions.map(x => ({
                                        value: x.id,
                                        label: x.name,
                                        id: x.id
                                    }))}
                                    inputId="gpoOptionId"
                                />
                            </div>
                        </FormControl>

                    </Grid>

                    <Grid item xs={3}>
                        <FormControl fullWidth disabled={isReadOnly || isDisabledForStaffManagement}>
                            {this.props.selectedHospital.serviceLevelId !== 0 &&
                                <InputLabel htmlFor='serviceLevelId' shrink>Service Level *</InputLabel>
                            }
                            <div className='align-bottom' style={{ paddingTop: '10px' }}>
                                <TypeAheadSelect
                                    value={
                                        this.props.selectedHospital.serviceLevelId
                                            ? (() => {
                                                const selected = this.props.serviceLevels.find(x => x.id === this.props.selectedHospital.serviceLevelId);
                                                return selected ? { value: selected.id, label: selected.name, id: selected.id } : null;
                                            })()
                                            : null
                                    }
                                    onChange={option => {
                                        const event = {
                                            target: {
                                                name: 'serviceLevelId',
                                                value: option ? option.value : ''
                                            }
                                        };
                                        this.props.handleBlur(event);
                                    }}
                                    placeholder="Service Level *"
                                    disabled={isReadOnly || isDisabledForStaffManagement}
                                    options={this.props.serviceLevels.map(x => ({
                                        value: x.id,
                                        label: x.name,
                                        id: x.id
                                    }))}
                                    inputId="serviceLevelId"
                                />
                            </div>
                        </FormControl>

                    </Grid>

                    <Grid item xs={3}>
                        <FormControl fullWidth disabled={isReadOnly || isDisabledForStaffManagement}>
                            {this.props.selectedHospital.hospitalTypeId &&
                                <InputLabel htmlFor='hospitalTypeId' shrink>Hospital Type</InputLabel>
                            }
                            <div className='align-bottom' style={{ paddingTop: '10px' }}>
                                <TypeAheadSelect
                                    value={
                                        this.props.selectedHospital.hospitalTypeId
                                            ? (() => {
                                                const selected = this.props.hospitalTypes.find(x => x.id === this.props.selectedHospital.hospitalTypeId);
                                                return selected ? { value: selected.id, label: selected.name, id: selected.id } : null;
                                            })()
                                            : null
                                    }
                                    onChange={option => {
                                        const event = {
                                            target: {
                                                name: 'hospitalTypeId',
                                                value: option ? option.value : ''
                                            }
                                        };
                                        this.props.handleBlur(event);
                                    }}
                                    placeholder="Hospital Type"
                                    disabled={isReadOnly || isDisabledForStaffManagement}
                                    options={this.props.hospitalTypes.map(x => ({
                                        value: x.id,
                                        label: x.name,
                                        id: x.id
                                    }))}
                                    inputId="hospitalTypeId"
                                />
                            </div>
                        </FormControl>

                    </Grid>

                    { /* Manager details - READ ONLY - Do not use disabled dropdown because option data should not be exposed to less privileged users. */}
                    {isReadOnly &&
                        <Grid item xs={3}>
                        <TextField id='analyticsManagerEmail' label='Analytics Manager' defaultValue={this.props.selectedHospital.analyticsManagerEmail || ''} key={this.props.selectedHospital.analyticsManagerEmail || ''}
                                disabled fullWidth inputProps={{ maxLength: "3" }} InputLabelProps={{ shrink: shrinkOverride }}
                            />
                        </Grid>
                    }
                    {isReadOnly &&
                        <Grid item xs={3}>
                        <TextField id='marketingManagerEmail' label='Marketing Manager' defaultValue={this.props.selectedHospital.marketingManagerEmail || ''} key={this.props.selectedHospital.marketingManagerEmail || ''}
                                disabled fullWidth inputProps={{ maxLength: "3" }} InputLabelProps={{ shrink: shrinkOverride }}
                            />
                        </Grid>
                    }
                    {isReadOnly &&
                        <Grid item xs={3}>
                        <TextField id='hrtManagerEmail' label='HR&T Manager' defaultValue={this.props.selectedHospital.hrtManagerEmail || ''} key={this.props.selectedHospital.hrtManagerEmail || ''}
                                disabled fullWidth inputProps={{ maxLength: "3" }} InputLabelProps={{ shrink: shrinkOverride }}
                            />
                        </Grid>
                    }
                    {isReadOnly &&
                        <Grid item xs={3}>
                            <TextField id='bookkeeperEmail' label='Bookkeeper' defaultValue={this.props.selectedHospital.bookkeeperEmail || ''} key={this.props.selectedHospital.bookkeeperEmail || ''}
                                disabled fullWidth inputProps={{ maxLength: "3" }} InputLabelProps={{ shrink: shrinkOverride }}
                            />
                        </Grid>
                    }
                    {isReadOnly &&
                        <Grid item xs={3}>
                            <TextField id='iVetUserAppUserAccessUserIds' label='Additional Access' value={additionalAccessUserNames || ''} key={additionalAccessUserNames || ''}
                                disabled fullWidth inputProps={{ maxLength: "3" }} InputLabelProps={{ shrink: shrinkOverride }}
                            />
                        </Grid>
                    }
                    { /* Manager details - EDITABLE - Render dropdowns. */}
                    {!isReadOnly &&
                        <Grid item xs={3}>
                            <FormControl fullWidth>
                                {(this.props.selectedHospital.analyticsManagerUserId) &&
                                    <InputLabel htmlFor='analyticsManagerUserId' shrink>Analytics Manager</InputLabel>
                                }

                                <div className='align-bottom' style={{ paddingTop: '10px' }}>
                                    <TypeAheadSelect
                                        value={
                                            this.props.selectedHospital.analyticsManagerUserId
                                                ? (() => {
                                                    const selected = this.props.staffUsers.find(x => x.id === this.props.selectedHospital.analyticsManagerUserId);
                                                    return selected ? { value: selected.id, label: selected.name, id: selected.id } : null;
                                                })()
                                                : null
                                        }
                                        onChange={option => {
                                            const event = {
                                                target: {
                                                    name: 'analyticsManagerUserId',
                                                    value: option ? option.value : null
                                                }
                                            };
                                            this.props.handleBlur(event);
                                        }}
                                        placeholder="Analytics Manager"
                                        options={[
                                            { value: null, label: 'None', id: 0 },
                                            ...this.props.staffUsers.map(x => ({
                                                value: x.id,
                                                label: x.name,
                                                id: x.id
                                            }))
                                        ]}
                                        inputId="analyticsManagerUserId"
                                    />
                                </div>
                            </FormControl>

                        </Grid>
                    }
                    {!isReadOnly &&
                        <Grid item xs={3}>
                            <FormControl fullWidth>
                                {this.props.selectedHospital.marketingManagerUserId
                                    ? <InputLabel htmlFor='marketingManagerUserId' shrink>Marketing Manager</InputLabel>
                                    : null}
                                <div className='align-bottom' style={{ paddingTop: '10px' }}>
                                    <TypeAheadSelect
                                        value={
                                            this.props.selectedHospital.marketingManagerUserId
                                                ? (() => {
                                                    const selected = this.props.staffUsers.find(x => x.id === this.props.selectedHospital.marketingManagerUserId);
                                                    return selected ? { value: selected.id, label: selected.name, id: selected.id } : null;
                                                })()
                                                : null
                                        }
                                        onChange={option => {
                                            const event = {
                                                target: {
                                                    name: 'marketingManagerUserId',
                                                    value: option ? option.value : null
                                                }
                                            };
                                            this.props.handleBlur(event);
                                        }}
                                        placeholder="Marketing Manager"
                                        options={[
                                            { value: null, label: 'None', id: 0 },
                                            ...this.props.staffUsers.map(x => ({
                                                value: x.id,
                                                label: x.name,
                                                id: x.id
                                            }))
                                        ]}
                                        inputId="marketingManagerUserId"
                                    />
                                </div>
                            </FormControl>

                        </Grid>
                   }
                    {!isReadOnly &&
                        <Grid item xs={3}>
                            <FormControl fullWidth>
                                {this.props.selectedHospital.hrtManagerUserId
                                    ? <InputLabel htmlFor='hrtManagerUserId' shrink>HR&amp;T Manager</InputLabel>
                                    : null}
                                <div className='align-bottom' style={{ paddingTop: '10px' }}>
                                    <TypeAheadSelect
                                        value={
                                            this.props.selectedHospital.hrtManagerUserId
                                                ? (() => {
                                                    const selected = this.props.staffUsers.find(x => x.id === this.props.selectedHospital.hrtManagerUserId);
                                                    return selected ? { value: selected.id, label: selected.name, id: selected.id } : null;
                                                })()
                                                : null
                                        }
                                        onChange={option => {
                                            const event = {
                                                target: {
                                                    name: 'hrtManagerUserId',
                                                    value: option ? option.value : null
                                                }
                                            };
                                            this.props.handleBlur(event);
                                        }}
                                        placeholder="HR&T Manager"
                                        options={[
                                            { value: null, label: 'None', id: 0 },
                                            ...this.props.staffUsers.map(x => ({
                                                value: x.id,
                                                label: x.name,
                                                id: x.id
                                            }))
                                        ]}
                                        inputId="hrtManagerUserId"
                                    />
                                </div>
                            </FormControl>

                        </Grid>
                    }

                    {!isReadOnly &&
                        <Grid item xs={3}>
                            <FormControl fullWidth>
                                {this.props.selectedHospital.bookkeeperUserId
                                    ? <InputLabel htmlFor='bookkeeperUserId' shrink>Bookkeeper</InputLabel>
                                    : null}
                                <div className='align-bottom' style={{ paddingTop: '10px' }}>
                                    <TypeAheadSelect
                                        value={
                                            this.props.selectedHospital.bookkeeperUserId
                                                ? (() => {
                                                    const selected = this.props.staffUsers.find(x => x.id === this.props.selectedHospital.bookkeeperUserId);
                                                    return selected ? { value: selected.id, label: selected.name, id: selected.id } : null;
                                                })()
                                                : null
                                        }
                                        onChange={option => {
                                            const event = {
                                                target: {
                                                    name: 'bookkeeperUserId',
                                                    value: option ? option.value : null
                                                }
                                            };
                                            this.props.handleBlur(event);
                                        }}
                                        placeholder="Bookkeeper"
                                        options={[
                                            { value: null, label: 'None', id: 0 },
                                            ...this.props.staffUsers.map(x => ({
                                                value: x.id,
                                                label: x.name,
                                                id: x.id
                                            }))
                                        ]}
                                        inputId="bookkeeperUserId"
                                    />
                                </div>
                            </FormControl>

                        </Grid>
                    }

                    <Grid item xs={3}>
                        <TextField id='monthlyBillRate' type='number' label='Monthly Bill Rate' defaultValue={this.props.selectedHospital.monthlyBillRate || ''} key={this.props.selectedHospital.monthlyBillRate || ''}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement}
                            fullWidth inputProps={{ maxLength: "18" }} InputLabelProps={{ shrink: shrinkOverride }}
                        />
                    </Grid>

                    <Grid item xs={3}>
                        <FormControl fullWidth disabled={isReadOnly || isDisabledForStaffManagement}>
                            {this.props.selectedHospital.reportBrandingId
                                ? <InputLabel htmlFor='reportBrandingId' shrink>Report Branding</InputLabel>
                                : null}
                            <div className='align-bottom' style={{ paddingTop: '10px' }}>
                                <TypeAheadSelect
                                    value={
                                        this.props.selectedHospital.reportBrandingId
                                            ? (() => {
                                                const selected = this.props.reportBrandings.find(x => x.id === this.props.selectedHospital.reportBrandingId);
                                                return selected ? { value: selected.id, label: selected.name, id: selected.id } : null;
                                            })()
                                            : null
                                    }
                                    onChange={option => {
                                        const event = {
                                            target: {
                                                name: 'reportBrandingId',
                                                value: option ? option.value : ''
                                            }
                                        };
                                        this.props.handleBlur(event);
                                    }}
                                    placeholder="Report Branding"
                                    disabled={isReadOnly || isDisabledForStaffManagement}
                                    options={this.props.reportBrandings.map(x => ({
                                        value: x.id,
                                        label: x.name,
                                        id: x.id
                                    }))}
                                    inputId="reportBrandingId"
                                />
                            </div>
                        </FormControl>
                    </Grid>

                    <Grid item xs={3}>
                        <TextField id='psiAccountNumber' label='External Account #' defaultValue={this.props.selectedHospital.psiAccountNumber || ''} key={this.props.selectedHospital.psiAccountNumber || ''}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement}
                            fullWidth inputProps={{ maxLength: "50" }} InputLabelProps={{ shrink: shrinkOverride }}
                        />
                    </Grid>

                    {!isReadOnly &&
                        <Grid item xs={3}>
                            <FormControl fullWidth>
                                <InputLabel htmlFor='iVetUserAppUserAccessUserIds' shrink={shrinkOverride}>Additional Access</InputLabel>
                                <Select
                                    value={this.props.selectedHospital.iVetUserAppUserAccessUserIds || ''}
                                    multiple
                                    renderValue={selected => this.props.staffUsers.filter(user => selected.find(id => id === user.id)).map(user => user.name).join(', ')}
                                    onChange={this.props.handleBlur}
                                    inputProps={{ name: 'iVetUserAppUserAccessUserIds' }}
                                >
                                    <MenuItem key={0} value={null}>None</MenuItem>
                                    {this.props.staffUsers.map(x => (
                                        <MenuItem key={x.id} value={x.id}>
                                            <Checkbox checked={this.props.selectedHospital.iVetUserAppUserAccessUserIds.indexOf(x.id) > -1} />
                                            {x.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    }

                    <Grid item xs={3}>
                        <TextField id='physicalLocations' label='# of Physical Locations *'
                            defaultValue={physicalLocations} key={physicalLocations}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement} fullWidth type="number" InputLabelProps={{ shrink: shrinkOverride }}
                        />
                    </Grid>

                    <Grid item xs={3}>
                        <TextField id='squareFootage' label='Square Footage'
                            defaultValue={this.props.selectedHospital.squareFootage || ''} key={this.props.selectedHospital.squareFootage || ''}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement} fullWidth type="number" InputLabelProps={{ shrink: shrinkOverride }}
                        />
                    </Grid>

                    <Grid item xs={3}>
                        <TextField id='examRooms' label='# of Exam Rooms'
                            defaultValue={examRooms} key={examRooms}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement} fullWidth type="number" InputLabelProps={{ shrink: shrinkOverride }}
                        />
                    </Grid>

                    <Grid item xs={3}>
                        <TextField id='examRoomsLastEditDate' type='date' InputLabelProps={{ shrink: true }} label='Exam Rooms Last Edit Date'
                            defaultValue={this.props.selectedHospital.examRoomsLastEditDate || ''} key={this.props.selectedHospital.examRoomsLastEditDate || ''}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement} fullWidth
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField id='notes' label='Notes' multiline
                            defaultValue={this.props.selectedHospital.notes || ''} key={this.props.selectedHospital.notes || ''}
                            onBlur={this.props.handleBlur} onChange={this.props.handleChange} disabled={isReadOnly || isDisabledForStaffManagement} fullWidth InputLabelProps={{ shrink: shrinkOverride }}
                        />
                    </Grid>
                </Grid>

                <br />

                {!isReadOnly &&  // Read only? Not an admin-- Hide.
                    <Grid container spacing={24} >
                        <Grid item xs={12}><h4 style={{ backgroundColor: 'lightgray', padding: '5px' }}>WEB LINKS</h4></Grid>

                        <Grid item xs={6}>
                            <TextField id='budgetReviewGoogleDocsUrl' label='Budget Review Link'
                                defaultValue={this.props.selectedHospital.budgetReviewGoogleDocsUrl || ''} key={this.props.selectedHospital.budgetReviewGoogleDocsUrl || ''}
                                onBlur={this.props.handleBlur} onChange={this.props.handleChange}
                                fullWidth inputProps={{ maxLength: "512" }}
                                disabled={isDisabledForStaffManagement}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <TextField id='marketingGoogleDocsUrl' label='Marketing Plan Link'
                                defaultValue={this.props.selectedHospital.marketingGoogleDocsUrl || ''} key={this.props.selectedHospital.marketingGoogleDocsUrl || ''}
                                onBlur={this.props.handleBlur} onChange={this.props.handleChange}
                                fullWidth inputProps={{ maxLength: "512" }}
                                disabled={isDisabledForStaffManagement}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <TextField id='eocScorecardGoogleDocsUrl' label='Employer of Choice Scorecard Link'
                                defaultValue={this.props.selectedHospital.eocScorecardGoogleDocsUrl || ''} key={this.props.selectedHospital.eocScorecardGoogleDocsUrl || ''}
                                onBlur={this.props.handleBlur} onChange={this.props.handleChange}
                                fullWidth inputProps={{ maxLength: "512" }}
                                disabled={isDisabledForStaffManagement}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <TextField id='hrReportsGoogleDocsUrl' label='HR Reports Link'
                                defaultValue={this.props.selectedHospital.hrReportsGoogleDocsUrl || ''} key={this.props.selectedHospital.hrReportsGoogleDocsUrl || ''}
                                onBlur={this.props.handleBlur} onChange={this.props.handleChange}
                                fullWidth inputProps={{ maxLength: "512" }}
                                disabled={isDisabledForStaffManagement}
                            />
                        </Grid>

                        <Grid item xs={12}><h4 style={{ backgroundColor: 'lightgray', padding: '5px' }}>API SETTINGS</h4></Grid>

                        <Grid item xs={6}>
                            <TextField id='gravityFormsConsumerKey' label='Gravity Forms API Key'
                                defaultValue={this.props.selectedHospital.gravityFormsConsumerKey || ''} key={this.props.selectedHospital.gravityFormsConsumerKey || ''}
                                onBlur={this.props.handleBlur} onChange={this.props.handleChange}
                                fullWidth inputProps={{ maxLength: "256" }}
                                disabled={isDisabledForStaffManagement}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <TextField id='gravityFormsConsumerSecret' label='Gravity Forms Secret'
                                defaultValue={this.props.selectedHospital.gravityFormsConsumerSecret || ''} key={this.props.selectedHospital.gravityFormsConsumerSecret || ''}
                                onBlur={this.props.handleBlur} onChange={this.props.handleChange}
                                fullWidth inputProps={{ maxLength: "256" }}
                                disabled={isDisabledForStaffManagement}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <TextField id='gravityFormsUrl' label='Gravity Forms URL'
                                defaultValue={this.props.selectedHospital.gravityFormsUrl || ''} key={this.props.selectedHospital.gravityFormsUrl || ''}
                                onBlur={this.props.handleBlur} onChange={this.props.handleChange}
                                fullWidth inputProps={{ maxLength: "256" }}
                                disabled={isDisabledForStaffManagement}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <TextField id='profileId' label='Google GA4 ID'
                                defaultValue={this.props.selectedHospital.profileId || ''} key={this.props.selectedHospital.profileId || ''}
                                onBlur={this.props.handleBlur} onChange={this.props.handleChange}
                                fullWidth inputProps={{ maxLength: "50" }}
                                disabled={isDisabledForStaffManagement}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            <TextField id='callTrackingSiteId' label='Call Tracking Site ID'
                                defaultValue={this.props.selectedHospital.callTrackingSiteId || ''} key={this.props.selectedHospital.callTrackingSiteId || ''}
                                onBlur={this.props.handleBlur} onChange={this.props.handleChange}
                                fullWidth type="number"
                                disabled={isDisabledForStaffManagement}
                            />
                        </Grid>

                        {/*<Grid item xs={6}>*/}
                        {/*    */}{/*<TextField id='callTrackingSiteId' label='Call Tracking Site ID'*/}
                        {/*    */}{/*    defaultValue={this.props.selectedHospital.callTrackingSiteId || ''} key={this.props.selectedHospital.callTrackingSiteId || ''}*/}
                        {/*    */}{/*    onBlur={this.props.handleBlur} onChange={this.props.handleChange}*/}
                        {/*    */}{/*    fullWidth type="number"*/}
                        {/*    */}{/*    disabled={isDisabledForStaffManagement}*/}
                        {/*    */}{/*/>*/}
                        {/*</Grid>*/}

                        <Grid item xs={6}>
                            <Grid container spacing={24}>
                                <Grid item xs={8}>
                                    <TextField id='installationId' label='VetData GUID or Vet ID Primary for VS/PV/SH'
                                        defaultValue={this.props.selectedHospital.installationId} key={this.props.selectedHospital.installationId}
                                        onBlur={this.props.handleBlur} onChange={this.props.handleChange}
                                        fullWidth inputProps={{ maxLength: "50" }}
                                        disabled={isDisabledForStaffManagement}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Button variant='contained' color='default' style={{ marginLeft: '15px' }}
                                        disabled={isDisabledForStaffManagement || !this.props.selectedHospital.idiVetUser}
                                        onClick={this.onClickReloadData}
                                    >Reload Data</Button>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={6}>
                            <TextField id='siteId' label='PMS Site ID'
                                defaultValue={this.props.selectedHospital.siteId || ''} key={this.props.selectedHospital.siteId || ''}
                                onBlur={this.props.handleBlur} onChange={this.props.handleChange}
                                fullWidth inputProps={{ maxLength: "4" }}
                                disabled={isDisabledForStaffManagement}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <TextField id='ezyVetSiteUid' label='EzyVet Site ID'
                                        defaultValue={this.props.selectedHospital.ezyVetSiteUid || ''} key={this.props.selectedHospital.ezyVetSiteUid || ''}
                                        onBlur={this.props.handleBlur} onChange={this.props.handleChange}
                                        fullWidth inputProps={{ maxLength: "50" }}
                                        disabled={isDisabledForStaffManagement}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField id='ezyVetClientId' label='EzyVet Client ID'
                                        defaultValue={this.props.selectedHospital.ezyVetClientId || ''} key={this.props.selectedHospital.ezyVetClientId || ''}
                                        onBlur={this.props.handleBlur} onChange={this.props.handleChange}
                                        fullWidth inputProps={{ maxLength: "256" }}
                                        disabled={isDisabledForStaffManagement}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={6}>
                            <Grid container spacing={24}>
                                <Grid item xs={8}>
                                    <TextField id='ezyVetClientSecret' label='EzyVet Client Secret'
                                        defaultValue={this.props.selectedHospital.ezyVetClientSecret || ''} key={this.props.selectedHospital.ezyVetClientSecret || ''}
                                        onBlur={this.props.handleBlur} onChange={this.props.handleChange}
                                        fullWidth inputProps={{ maxLength: "256" }}
                                        disabled={isDisabledForStaffManagement}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                <FormControlLabel component="fieldset" style={{ paddingLeft: '30px', display: 'flex' }} disabled={isReadOnly || isDisabledForStaffManagement}
                                    label='Power BI Payments'
                                    labelPlacement='end'
                                    control={
                                        <Checkbox
                                            checked={this.props.selectedHospital.powerBiPayments}
                                            onChange={(e) => this.props.handleCheckboxChange(e, 'powerBiPayments')}
                                            value={'powerBiPayments'}
                                            color='primary'
                                        />
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={6}>
                            <TextField id='intacctLocationId' label='Location ID'
                                defaultValue={this.props.selectedHospital.intacctLocationId || ''} key={this.props.selectedHospital.intacctLocationId || ''}
                                onBlur={this.props.handleBlur} onChange={this.props.handleChange} fullWidth inputProps={{ maxLength: "256" }}
                                disabled={isDisabledForStaffManagement}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <TextField id='dataPointSiteId' label='Data Point Site ID'
                                defaultValue={this.props.selectedHospital.dataPointSiteId || ''} key={this.props.selectedHospital.dataPointSiteId || ''}
                                onBlur={this.props.handleBlur} onChange={this.props.handleChange}
                                fullWidth type="number"
                                disabled={isDisabledForStaffManagement}
                            />
                        </Grid>
                    </Grid>
                }
                <br />
                {!isReadOnly && this.renderSaveCancel(12)}
                <br />
                <br />

                <ModalOKCancel
                    title="Load History"
                    body={`Reload Google Analytics for ${this.props.selectedHospital.name}?`}
                    show={this.state.showReloadGoogleAnalyticsModal}
                    onOK={this.onReloadGoogleAnalyticsOK.bind(this)}
                    onCancel={this.onReloadGoogleAnalyticsCancel.bind(this)}
                />
                <ModalOKCancel
                    title="Reload Data"
                    body={`Reload Data for ${this.props.selectedHospital.name}?`}
                    show={this.state.showReloadDataModal}
                    onOK={this.onReloadDataOK.bind(this)}
                    onCancel={this.onReloadDataCancel.bind(this)}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Hospitals/Details.js